// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"cf62e4da","75":"88212757","395":"4d702517","422":"23ea3dd1","457":"d67ac7b2","594":"a7390503","629":"fd5853f7","710":"63c251c2","837":"9e8d1da7","869":"48f25a06"}[chunkId] + ".chunk.js";
};